import React from 'react'
import { locationPackageVS } from 'services/validations/catalog/packages/locationPackage'
import ProductPackageBaseFormProvider from '../ProductPackageBaseFormProvider'
import LocationPresetAdditionalFields from './LocationAdditionalFields'

const LocationPackageForm: React.FC = () => (
  <ProductPackageBaseFormProvider
    entity="locations"
    validationSchema={locationPackageVS}
    presetInputFields={<LocationPresetAdditionalFields />}
  />
)

export default LocationPackageForm
